import React, { useState, useEffect } from 'react';
import CircleProgressChart from './CircleProgressChart.jsx';
import ProgressBarComponent from './ProgressBarComponent.jsx';
import useAverageScoreEffect from '../hooks/useAverageScoreEffect';

const formatProductId = (id) => {
  if (!id) return null;
  const trimmedId = String(id).replace(/^0+/, '');
  return trimmedId.padStart(13, '0');
};

const StatisticScoreCard = ({
  title,
  categories,
  iconSrc,
  productId,
  onBarClick,
  average_scores,
  t,
}) => {
  const [isNotScore, setIsNotScore] = useState(false);
  const [average_score, setAverageScore] = useState(0);

  const formattedProductId = formatProductId(productId);

  useEffect(() => {
    const reply =
      categories?.length && categories.some((category) => category.score === 0);
    setIsNotScore(!!reply);
  }, [categories]);

  useAverageScoreEffect(average_scores, title, setAverageScore);

  return (
    <div
      className="rounded-2xl relative h-full"
      style={{
        backgroundColor: '#f5f5f6',
        borderRadius: 16,
        padding: '24px 16px 20px 16px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        className="flex items-center justify-center gap-2.5 text-center"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}
      >
        <h2 className="m-0 font-bold" style={{ fontSize: '1.5rem' }}>{t ? t(title) : title}</h2>
        {title !== 'Hälsa' && (
          <img
            src={iconSrc || ''}
            alt={t ? t('Icon') : 'Icon'}
            style={{ height: 20, marginRight: 10 }}
          />
        )}
        {title === 'Hälsa' && (
          <svg style={{ height: '1.5rem', marginRight: '10px' }} viewBox="0 0 66.78 57.43">
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  style={{ fill: '#ff8da3' }}
                  d="M33.39,57.43C31.42,56,11.8,41.36,6,34.08A25.19,25.19,0,0,1,.06,20.25,18.23,18.23,0,0,1,6.53,4.66a18.71,18.71,0,0,1,24.33-.33c.92.76,1.77,1.6,2.53,2.29.76-.69,1.61-1.53,2.53-2.29a18.69,18.69,0,0,1,24.32.33,18.18,18.18,0,0,1,6.47,15.59,25.12,25.12,0,0,1-5.9,13.83C55,41.36,35.36,56,33.39,57.43Z"
                />
              </g>
            </g>
          </svg>
        )}
      </div>
      <div
        className="flex justify-center"
        style={{
          position: 'relative',
          height: 180,
          margin: '16px 0',
          transform: 'translateY(-16px)',
        }}
      >
        <CircleProgressChart
          name={title}
          score={average_score}
          strokeWidth={16}
          originalSize={260}
          originalRadius={90}
          t={t}
        />
      </div>
      {title === 'Hälsa' ? (
        <span
          className="block pl-2.5 text-base font-bold leading-snug"
          style={{ margin: '4rem 0 0 0', paddingLeft: 10, fontSize: '0.85rem', lineHeight: 1.4 }}
        >
          {t ? t('Hälsopoängen baseras enbart på Hälsa:') : 'Hälsopoängen baseras enbart på Hälsa:'}
        </span>
      ) : (
        <span
          className="block pl-2.5 font-bold leading-snug"
          style={{ margin: '4rem 0 0 0', paddingLeft: 10, fontSize: '0.85rem', lineHeight: 1.4 }}
        >
          {t ? t('I denna kategori ingår följande parametrar:') : 'I denna kategori ingår följande parametrar:'}
        </span>
      )}

      {categories.map((category) => (
        <div className="my-3" key={category.name}>
          <a
            href={
              formattedProductId
                ? `#/product/parameters-details/${formattedProductId}/${category.engName}`
                : '#demo'
            }
            className="no-underline text-black hover:no-underline hover:text-black"
            onClick={(e) => {
              if (onBarClick) {
                e.preventDefault();
                onBarClick(category.engName);
              }
            }}
          >
            <ProgressBarComponent
              name={category.name}
              score={category.score}
              bonus={category.bonus}
              isIcon={true}
              t={t}
            />
          </a>
        </div>
      ))}

      <div
        className="flex flex-wrap items-center absolute left-0 right-0 text-[0.7rem] pl-2"
        style={{
          bottom: 8,
          paddingLeft: '0.7rem',
        }}
      >
        {isNotScore && (
          <small>
            {t ? `● = ${t('Information saknas')}` : '● = Information saknas '}
            {productId && (
              <>
                <strong> {t ? t('eller') : 'eller'}</strong>{' '}
                {t ? t('Ej tillämplig på denna produktkategori') : 'Ej tillämplig på denna produktkategori'}
              </>
            )}
          </small>
        )}
      </div>
    </div>
  );
};

export default StatisticScoreCard;
